import React from 'react';
import styled from 'styled-components/macro';
import ContentLoader from 'components/utility/ContentLoader/ContentLoader';

const Wrapper = styled('div')<any>`
  margin-top: 35px;
`;

const KPILoader = ({ oneLine }: any): JSX.Element => {
  if (oneLine) {
    return (
      <Wrapper>
        <ContentLoader width={375} height={25}>
          <rect width="70" height="16" x="20" y="0" />
          <rect width="65" height="16" x="100" y="0" />
        </ContentLoader>
      </Wrapper>
    );
  }
  return (
    <Wrapper>
      <ContentLoader width={375} height={86}>
        <rect width="70" height="16" x="20" y="0" />
        <rect width="65" height="16" x="100" y="0" />
        <>
          <rect width="75" height="16" x="20" y="35" />
          <rect width="65" height="16" x="105" y="35" />
        </>
        <>
          <rect width="15" height="16" x="0" y="70" />
          <rect width="65" height="16" x="20" y="70" />
          <rect width="80" height="16" x="95" y="70" />
        </>
      </ContentLoader>
    </Wrapper>
  );
};

export default KPILoader;
